<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="动物类型">
            <animal-select style="width: 100%" v-decorator="['animalTypeCode']" />
            <!-- , { rules: [{ required: true, message: '请选择动物类型' }] } -->
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item
            label="线路"
          >
            <a-select v-decorator="['lineId', { rules: [{ required: true, message: '选择线路' }] }]" placeholder="选择线路">
              <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                {{el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="配方名称">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['formulaName']" placeholder="请输入名称" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="配方类型">
            <a-select size="small" placeholder="配方类型" v-decorator="['formulaType', { rules: [{ required: true, message: '请选择配方类型' }] }]" style="width: 100%">
              <a-select-option v-for="i in [{name:'配合饲料',code: '1'},{name:'混合日粮',code: '2'}]" :key="i.code">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="营养指标" style="height: 40px;">
            <a-select
              allowClear
              show-search
              placeholder="请输入营养指标"
              style="width: 100%;overflow: auto;margin-top: 9px;height: 24px;"
              size='small'
              :default-active-first-option="false"
              :filter-option="false"
              :not-found-content="null"
              @search="getSearchList"
              @select="onSelect"
              v-decorator="['nutritionIds']"
              @inputKeydown='inputKeydown'
            >
              <a-select-option v-for="d in searchList" :key="d.id">
                {{d.firstName}}<span style="color: red">{{d.midName}}</span>{{d.lastName}}({{d.code}})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6">
          <a-form-item label="工厂">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['factoryKeyword']" placeholder="请输入工厂" />
          </a-form-item>
        </a-col> -->
        <a-col :span="6">
          <a-form-item label="工厂">
            <!-- <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['factoryKeyword']" placeholder="请输入工厂" /> -->
            <a-select
              placeholder="请选择工厂"
              size='small'
              v-decorator="['factoryIds']"
            >
              <a-select-option v-for="i in factoryList" :key="i.factoryId">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6">
          <a-form-item label="营养师">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['authorName']" placeholder="请输入营养师" />
          </a-form-item>
        </a-col> -->

        <a-col :span="6" class="submitBtnBox">
          <a-button type="primary" class="btnMar" :disabled="selectedList.length !== 2" @click="analyseModalFunc">
            执行对比
          </a-button>
          <a-button type="primary" class="btnMar" @click="getListHandle">
            查询
          </a-button>
          <a-button v-if="hasPermission('nhExport')" :loading="downloading" type="primary" class="btnMar" @click="exportFile">
            导出
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>

    <!-- <div class="editBox">
      <a-button type="primary" @click="analyseModalFunc">
        + 添加
      </a-button>
      <a-button @click="deleteData" type="danger" ghost>
        删除
      </a-button>
    </div> -->
    <!-- :scroll="{y: 500}" -->
    <a-table
      ref="listRef"
      id="table-dom"
      :row-key="
        record => {
          if (record.children) {
            return record.id
          }
          return record.id + record.nutritionName
        }
      "
      :loading="loading"
      :columns="columns"
      :data-source="list"
      class="tableBox"
      :pagination="pagination"
      :scroll="{ y, x: 1000 }"
      bordered
    >
      <template slot="factoryName" slot-scope="text, record">
        <a-checkbox :disabled="disabledFn(record)" @change="e => checkboxChange(e, record)" :checked="selectedList && selectedList.map(v => v.id).includes(record.id)"><span style="font-size: 12px">{{ record.factoryName }}</span></a-checkbox>
      </template>
    </a-table>
    <!-- 新增 -->

    <Analyse ref="analyse" class="modalBox" :visible.sync="analyseModal" :ary="ary" />
  </div>
</template>
<script>
import { columns, pagination,columns2 } from './config'
import { TpWatermark } from '../utils'

import * as API from './api'
import Analyse from './components/Analyse.vue'
import AnimalSelect from '../MaterialAnalyse/components/AnimalSelect.vue'
export default {
  name: 'NutritionAnalyse',
  props: {
    menuBtnList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    Analyse,AnimalSelect
  },
  mounted() {
    TpWatermark('table-dom', localStorage.getItem('userName') + ' newhope', '150', '450', '-5', 'grey', '50', '0.06')
    this.y = this.$refs.listRef.$el.offsetHeight - 100
    this.form.setFieldsValue({formulaType: '1'})
  },
  watch: {},
  data() {
    return {
      y: 380,
      typeList: [],
      factoryList: [],
      form: this.$form.createForm(this, { name: 'EvalueTool' }),
      selectedList: [],
      // selectedFormulaCode: null,
      confirmLoading: false,
      analyseModal: false, // 是否显示弹窗
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      loading: false,
      downloading: false,
      pagination: {
        ...pagination,
        onChange: (current, size) => {
          this.pagination.current = current
          this.getList({ current, pageSize:size })
        }, //选择页数
        onShowSizeChange: (current, size) => {
          this.pagination.pageSize = size
          this.pagination.current = 1
          this.getList({ current: 1, pageSize:size })
        } //每页多少条
      },
      list: [],
      changedRows: {},
      // columns,
      lineList: [],
      searchList:[],
      columns2,
      noMartial: false,
      ary: []
    }
  },
  computed: {
    editColumns() {
      return this.columns.filter(item => item.editable).map(v => v.dataIndex)
    },
    columns(){
      return this.noMartial ? columns : columns2
    }
  },
  created() {
    // this.getList()
    this.factoryGet()
    this.getTypeList2()
  },
  beforeMount() {
    this.y = window.innerHeight - 400
  },
  methods: {
    getTypeList2(){
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`,{params}).then(res => {
        let { success, data } = res
        if (success) {
          let {records} = data || {}
          records&&records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList = records || []
          this.getLineList()
        }
      })
    },
    getLineList(){
      let staffId = window.localStorage.getItem('staffId')
      if(!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        // let {success,data} = res || {}
        if(data && data.length > 0){
          data = data.sort((a,b) => a - b)
          let lineList = []
          this.typeList && this.typeList.forEach(el => {
            if(data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.animalRootId = data[0]
          this.form.setFieldsValue({lineId: data[0] || ''})
          // setTimeout(() => {
          //   this.getList()
          // }, 0);
        }
      })
    },
    inputKeydown(e){
      if(e.keyCode === 13) this.getList({current:1,pageSize:20})
    },
    getSearchList(name){
      if(name){
        setTimeout(() => {
          this.placeStr = name || '请输入营养指标名称/代码'
          this.form.setFieldsValue({name})
            this.$get('/nhf-core-data/nutritiontarget/nutritionUserPage',{
              current: 1,
              size:100,
              // factoryId: window.localStorage.getItem('factoryId'),
              searchKey:name
              }).then(res => {
              let {success,data} = res;
              if(success){
                let {records} = data || {}
                records.map(el => {
                  let nameArr = el.name.split(name)
                  el.firstName = nameArr[0]
                  el.lastName = nameArr[1]
                  el.midName = name
                  return el
                })
                this.searchList = records || []
              }else{
                this.searchList = []
              }
            }).catch(() => {
              this.searchList = []
            })
        }, 300);
      }
    },
    onSelect(val){
      this.selectedList = []
      this.getList({pageSize:this.pagination.pageSize,current:1,val})
    },
    hasPermission(code) {
      const codes = []
      const fn = ary => {
        ary.forEach(a => {
          codes.push(a.code)
          if (a.children) {
            fn(a.children)
          }
        })
      }
      fn(this.menuBtnList)
      return codes.includes(code)
    },
    async exportFile() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.downloading = true
      await API.exportFile(valid).catch(e => {
        e.message && this.$message.error(e.message)
      })
      this.downloading = false
    },
    disabledFn(row) {
      const limit = 2
      if (this.selectedList.map(v => v.id).indexOf(row.id) !== -1) {
        return false
      }
      // if (this.selectedFormulaCode && this.selectedList.length < limit) {
      //   return row.formulaCode !== this.selectedFormulaCode
      // }
      return this.selectedList.length >= limit
    },
    checkboxChange(e, row) {
      const { checked } = e.target
      if (checked) {
        this.selectedList.push(row)
        // this.selectedFormulaCode = row.formulaCode
      } else {
        this.selectedList = this.selectedList.filter(v => v.id !== row.id)
        // if (this.selectedList.length === 0) {
        // this.selectedFormulaCode = null
        // }
      }
    },
    filterOption(inputValue, option) {
      try {
        return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
      } catch (e) {
        return false
      }
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      setTimeout(() => {
        targetOption.loading = false
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0)
    },

    resetFields() {
      this.selectedList = []
      // this.form.resetFields()
      this.form.setFieldsValue({animalTypeCode: undefined,formulaName: null,nutritionIds: null,factoryKeyword: null,authorName: null,factoryIds: undefined})
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption)
    },
    getListHandle() {
      this.selectedList = []
      this.pagination.current = 1
      return this.getList(this.pagination)
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.loading = true
      let { current = 1, size = 20 } = pagination || this.pagination
      let { ...newdata } = valid
      let params = {
        staffId: localStorage.getItem('staffId'),
        ...newdata,
        requestType: 2,
        current,
        size: size
      }
      let feild = 'nutritionGet2'
      if(newdata.nutritionIds){
        feild = 'nutritionGet'
        // params.nutritionIds = params.nutritionIds.join(',')
        this.noMartial = false
      }
      await API[feild](params)
      // await API.nutritionGet(params)
        .then(res => {
          let { success, data } = res
          if (success) {
            let { records = [], current = 1, total = 0, size = 10 } = data
            this.list = records
            this.pagination.current = current
            this.pagination.total = total
            this.pagination.pageSize = size
          } else {
            this.$message.error('查询失败')
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          e.message && this.$message.error(e.message)
        })
      this.loading = false
    },
    getTypeList(parentId = '0', record, type) {
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let { success, data = [] } = res
        if (success) {
          data &&
            data.map(el => {
              el.value = el.id
              el.label = el.name
              el.isLeaf = !el.hasChildren
              // el.isLeaf = false
              return el
            })
          if (record) {
            // data = [
            //   {name: '测试1',id: '测试1',value: '测试1',label: '测试1',isLeaf: '测试1'}
            // ]
            if (data.length) {
              record.children = data
            } else {
              record.isLeaf = true
            }
            if (!type) {
              this.typeList = [...this.typeList]
            } else {
              this.list = [...this.list]
            }

            if(type) {
              this.form.setFieldsValue({lineId: this.typeList[0].children[0].id || ''})
              this.lineList = data
            }
          } else {
            this.typeList = data
          }
          // this.typeList = data
          // return data
        } else {
          this.typeList = []
        }
        // if(type) this.getLineList()
        if(parentId === '0'){
          this.getTypeList(this.typeList[0].id,this.typeList[0],true)
        }
      })
    },
    async factoryGet() {
      let params = {
        current: 1,
        size: 100,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records} = data;
        this.factoryList = records || [];
      }
    },
    // analyseModalFunc() {
    //   // 新增显示或关闭
    //   this.analyseModal = !this.analyseModal
    // }
    async analyseModalFunc() {
      // 新增显示或关闭// 新增显示或关闭
      const valid = await this.form.validateFields()
      let formulaIds = []
      let flag = true
      let requestType = 1
      let {lineId} = valid || {}
      this.selectedList.forEach(el => {
        if(el.children) flag = false
        formulaIds.push(el.id)
      })
      if(flag){
        await API.nutritionGet({
          formulaIds:formulaIds.join(','),lineId,requestType,
          current: 1,size: 5000
        }).then(res => {
          let { success, data } = res
          if(success){
            let {records} = data || {}
            this.ary = records || []
            setTimeout(() => {
              this.analyseModal = !this.analyseModal
            }, 0);
          }
        })
      }else{
        this.ary = this.selectedList
        setTimeout(() => {
          this.analyseModal = !this.analyseModal
        }, 0);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  // height: calc(100% - 36px);
  .tableBox {
    height: calc(100% - 132px);
    min-height: 240px;
  }
}
#table-dom {
  position: relative;
}
::v-deep .ant-table-thead > tr > th {
  padding: 0px;
}
</style>
